export default __webpack_public_path__ + "e40191845242335ca3524e8f55d6efb8.svg";